<div class="patient-disabled-modal">
  <app-register-new-patient
    #REGISTERPATCOMP
    *ngIf="patient"
    [editDetails]="patient"
    [isEdit]="true"
    [isPatientDisabled]="isPatientDisabled"
    [showMissingMandatoryParams]="true"
    (close)="handleClose($event)">
  </app-register-new-patient>
</div>

